<div class="container">
	<div class="top-container mt-5">
		<form
			class="form"
			#nameForm="ngForm"
			novalidate
			(ngSubmit)="saveNameForm(registrationPlatesVinNumber)"
		>
			<input
				[(ngModel)]="registrationPlatesVinNumber"
				name="platesVin"
				#platesVin="ngModel"
				placeholder="Kërko numrin e targave të makinës apo numrin VIN…"
				nbInput
			/>
			<button
				id="button"
				type="submit"
				class="blue-button ml-2"
				routerLink="/scenario-forth-results/{{ registrationPlatesVinNumber }}"
				[disabled]="platesVin.invalid"
			>
				KËRKO
			</button>
		</form>
		<span
			id="button"
			class="text-danger ml-2 mt-4"
			*ngIf="platesVin && platesVin.invalid && platesVin.touched"
			>Ju lutem shkruani numrin përsonal për të vazhduar</span
		>
	</div>
	<div
		*ngIf="
			platesVinResults !== undefined && platesVinResults !== null;
			else noResults
		"
	>
		<div>
			<p class="paragraph mt-4 mb-4">19UUB3F77GA001198</p>
			<nb-card class="first-card">
				<p class="dark-paragraph mb-4">
					Kjo veturë figuron në listën e aksidenteve të raportuara në territorin
					e Republikës së Kosovës si vijon:
				</p>
				<button class="blue-button">
					Konsiderohet rast potencial i mashtrimit
				</button>
			</nb-card>

			<nb-card class="table-card">
				<p class="blue-paragraph mb-4">
					Aksidentet e trafikut gjatë periudhës 2 vjeqare
				</p>

				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<th>
									<p class="dark-paragraph">
										DATA E AKSIDENTIT
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										VIN
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										LLOJI I DËMIT
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										VLERA E KËRKESES
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										SHKAKTAR / DËMTUAR
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										VETURA TË PËRFSHIRA
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										KOMPANIA E SIGURIMEVE
									</p>
								</th>
							</tr>
						</thead>

						<tbody *ngFor="let item of platesVinResults">
							<tr class="grey">
								<td>
									<p class="short-paragraph ml-2">
										{{ item?.accidentDate | date: 'shortDate' }}
									</p>
								</td>
								<td>
									<p class="short-paragraph">
										{{ item?.vehicleIdentificationNumber }}
									</p>
								</td>
								<td>
									<p class="short-paragraph">{{ item?.claimType }}</p>
								</td>

								<td>
									<p class="short-paragraph">10.00 €</p>
								</td>
								<td>
									<p class="short-paragraph">Shkaktar</p>
								</td>
								<td class="table-item d-flex">
									<p class="short-paragraph">
										1
									</p>
									<p class="blue-paragraph ml-3">Shiko detajet</p>
								</td>
								<td>
									<p class="short-paragraph">Prisig</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</nb-card>

			<nb-card class="table-card">
				<p class="paragraph mb-3">
					Vetura e 2-të e përfshirë në aksidentin e datës 06/07/2020
				</p>
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<th>
									<p class="dark-paragraph">
										EMRI DHE MBIEMRI
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										VIN
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										LLOJI I DËMIT
									</p>
								</th>
								<th>
									<p class="dark-paragraph">
										VLERA E KËRKESËS
									</p>
								</th>
								<th>
									<p class="dont-show">
										VETURA TË PËRFSHIRA
									</p>
								</th>
								<th>
									<p class="dont-show">
										VETURA TË PËRFSHIRA
									</p>
								</th>
								<th>
									<p class="dont-show">
										VETURA TË PËRFSHIRA
									</p>
								</th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>
									<p class="short-paragraph ml-2">07/08/2020</p>
								</td>
								<td>
									<p class="short-paragraph">19UUB3F77GA001198</p>
								</td>
								<td>
									<p class="short-paragraph">Dëme materiale</p>
								</td>
								<td>
									<p class="short-paragraph">10.00 €</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</nb-card>
		</div>
		<div class="action-button d-flex">
			<button class="blue-button">
				SHKARKO
			</button>
		</div>
	</div>
</div>

<ng-template #noResults>
	<div class="container" *ngIf="platesVinResults !== undefined; else loading">
		<nb-card class="card mt-5">
			<p class="blue-paragraph">
				Nuk janë gjetur rekorde të aksidentit për këtë numër personal
			</p>
		</nb-card>
	</div>
</ng-template>

<ng-template #loading>
	<div
		class="loading"
		[nbSpinner]="loading"
		nbSpinnerSize="giant"
		nbSpinnerStatus="primary"
	></div>
</ng-template>
